import {useLayoutEffect, useState} from "react";

// The `id` attributes on DOM elements in Shell Application
const gridTemplateIds = ["header", "nav", "content"];

const useShellPositioning = () => {
  const [pos, setPos] = useState(
    gridTemplateIds.reduce((domRects, id) => {
      // window.__SHELL__.layout uses "sidebar" as the nav's id, so keep it consistent
      domRects[id === "nav" ? "sidebar" : id] = new DOMRect();
      return domRects;
    }, {})
  );

  useLayoutEffect(() => {
    // Not in Shell app
    if (!window.__SHELL__) {
      return;
    }

    const positions = {};

    gridTemplateIds.forEach((id) => {
      const el = document.querySelector(`#${id}`);
      if (el) {
        positions[id === "nav" ? "sidebar" : id] = el.getBoundingClientRect();
      }
    });

    /**
     * @todo Once Shell layout is in stable place, uncomment below so
     * that we can reference window.__SHELL__ moving forward.
     */

    // Shell layout object structure: { layoutId: { ref: <ReactRef>, position: <DOMRect> } }
    // const shellLayout = window.__SHELL__.layout;

    // if (shellLayout) {
    //   Object.entries(shellLayout).forEach(([id, {position}]) => {
    //     positions[id] = position;
    //   });
    // } else {
    //   gridTemplateIds.forEach((id) => {
    //     const el = document.querySelector(`#${id}`);
    //     if (el) {
    //       positions[id === "nav" ? "sidebar" : id] = el.getBoundingClientRect();
    //     }
    //   });
    // }

    setPos((state) => ({
      ...state,
      ...positions
    }));
  }, []);

  return pos;
};

export default useShellPositioning;
